import React, { useMemo } from "react";

import { IActiveLearningIssue } from "../../../../../../state";
import Button from "../../../../../../atoms/ActiveLearning/Button";
import TreeCard from "../../../../../../atoms/ActiveLearning/TreeCard";
import styles from "../../../ActiveLearningIssue.module.scss";
import { ReactComponent as IconAdd } from "../../../../../../assets/images/ActiveLearning/icon_add.svg";
import hintImage16 from "../../../../../../assets/images/ActiveLearning/hint/img_16.webp";

type Issue2MaterialProps = {
  issue?: IActiveLearningIssue;
};

export const Issue2Material = (props: Issue2MaterialProps) => {
  const question = useMemo(() => {
    const q = props.issue?.questions.find(q => q.order_num === 1);
    if (q) return q;
  }, [props.issue]);

  return (
    <div className={styles.issue}>
      <div className={styles.header}>
        <span className={styles.no}>
          WORK
          {props.issue?.no && props.issue?.no < 10
            ? `0${props.issue?.no}`
            : props.issue?.no}
        </span>
        <p className={styles.title}>{props.issue?.title}</p>
        <p className={styles.read}>
          行動した結果をもとに、ステップを書き換えたり、書き加えたりしてみよう。
        </p>
      </div>
      {question && (
        <div className={styles.question}>
          <div className={styles.tree}>
            <TreeCard
              title={"解決のアイデア"}
              text={"回答データがありません。"}
            />
            <div className={styles.buttonWrapper}>
              <Button width={"150px"} height={"37px"} fontSize={"14px"}>
                <IconAdd />
                項目を追加する
              </Button>
            </div>
          </div>
        </div>
      )}
      <img src={hintImage16} alt="ステップを調整するためのヒント" />
    </div>
  );
};
export default Issue2Material;
